// src/dashboard/data/FormSchemas.js

export const FORM_SCHEMAS = {
  // --- 1. DONATIONS SCHEMA (CRITICAL FIX) ---
  'donations-list': [
    { name: 'name', label: 'Donor Name', type: 'text' },
    { name: 'amount', label: 'Amount (₹)', type: 'number' }, // Shows Amount
    { name: 'payment_id', label: 'Payment Ref', type: 'text' },
    { name: 'email', label: 'Email ID', type: 'email' },
    { name: 'phone', label: 'Phone', type: 'tel' },
    { name: 'pan_number', label: 'PAN', type: 'text' },
    { name: 'donation_date', label: 'Date', type: 'date' },
  ],

  // --- 1. GENERAL FORMS (Navbar & Hero) ---
  'supporter-form': [
    { name: 'full_name', label: 'Full Name', type: 'text' },
    { name: 'father_name', label: 'Father Name', type: 'text' },
    { name: 'address', label: 'Address', type: 'textarea' },
    { name: 'phone_no', label: 'Phone', type: 'tel' },
    { name: 'email_id', label: 'Email', type: 'email' },
    { name: 'aadhaar_no', label: 'Aadhaar', type: 'text' },
    { name: 'pan_card_no', label: 'PAN', type: 'text' },
    { name: 'qualification', label: 'Qualification', type: 'text' },
    { name: 'occupation', label: 'Occupation', type: 'text' },
    { name: 'areas_of_interest', label: 'Interests', type: 'text' },
    { name: 'support_mode', label: 'Support Mode', type: 'text' },
    { name: 'status', label: 'Status', type: 'text' }
  ],
  // Alias other supporter tabs to the same structure (Dynamic Mapping would optionally be better, but explicit is safer here)
  // BETTER APPROACH: In DataTable, we default to supporter-form schema if specific one is empty/missing but logic implies similarity.
  // BUT the provided DataTable uses `FORM_SCHEMAS[type] || FORM_SCHEMAS['volunteer-form']`.
  // So we MUST define them or change DataTable logic.
  // Let's copy the array for now to ensure it works 100%.

  'education-supporter': [
    { name: 'full_name', label: 'Full Name', type: 'text' }, { name: 'phone_no', label: 'Phone', type: 'tel' }, { name: 'areas_of_interest', label: 'Interests', type: 'text' }, { name: 'support_mode', label: 'Support', type: 'text' }
  ],
  'cricket-supporter': [
    { name: 'full_name', label: 'Full Name', type: 'text' }, { name: 'phone_no', label: 'Phone', type: 'tel' }, { name: 'areas_of_interest', label: 'Interests', type: 'text' }, { name: 'support_mode', label: 'Support', type: 'text' }
  ],
  'music-supporter': [
    { name: 'full_name', label: 'Full Name', type: 'text' }, { name: 'phone_no', label: 'Phone', type: 'tel' }, { name: 'areas_of_interest', label: 'Interests', type: 'text' }, { name: 'support_mode', label: 'Support', type: 'text' }
  ],
  'business-supporter': [
    { name: 'full_name', label: 'Full Name', type: 'text' }, { name: 'phone_no', label: 'Phone', type: 'tel' }, { name: 'areas_of_interest', label: 'Interests', type: 'text' }, { name: 'support_mode', label: 'Support', type: 'text' }
  ],
  'awards-supporter': [
    { name: 'full_name', label: 'Full Name', type: 'text' }, { name: 'phone_no', label: 'Phone', type: 'tel' }, { name: 'areas_of_interest', label: 'Interests', type: 'text' }, { name: 'support_mode', label: 'Support', type: 'text' }
  ],

  'volunteer-form': [
    { name: 'fullName', label: 'Full Name', type: 'text', required: true },
    { name: 'fatherName', label: 'Father Name', type: 'text', required: true },
    { name: 'address', label: 'Full Address', type: 'textarea', required: true },
    { name: 'phone', label: 'Phone Number', type: 'tel', required: true },
    { name: 'email', label: 'Email ID', type: 'email' },
    { name: 'aadhar', label: 'Aadhaar No', type: 'text' },
    { name: 'pan', label: 'PAN Card', type: 'text' },
    { name: 'qualification', label: 'Qualification', type: 'text' },
    { name: 'occupation', label: 'Occupation', type: 'text' },
    { name: 'club_preference', label: 'Club Preference', type: 'text' },
    // NEW: Requested Availability Options
    { name: 'availability', label: 'Availability', type: 'text' },
    // NEW: Dynamic Date/Time
    { name: 'start_date', label: 'Start Date', type: 'date' },
    { name: 'end_date', label: 'End Date', type: 'date' },
    // NEW: File Upload
    { name: 'aadhaar_path', label: 'Aadhaar Card', type: 'file' },
    { name: 'photo_path', label: 'Photo', type: 'file' }
  ],

  // --- 2. CRICKET CLUB ---
  'cricket-club-member': [
    { name: 'full_name', label: 'Member Name', type: 'text' },
    { name: 'father_name', label: 'Father Name', type: 'text' },
    { name: 'phone_no', label: 'Phone', type: 'text' },
    { name: 'category', label: 'Category', type: 'text' },
    { name: 'aadhaar_path', label: 'Aadhaar', type: 'file' },
    { name: 'disability_cert_path', label: 'Certificate', type: 'file' },
    { name: 'photo_path', label: 'Photo', type: 'file' }
  ],
  'cricket-player': [
    { name: 'full_name', label: 'Player Name', type: 'text' },
    { name: 'father_name', label: 'Father Name', type: 'text' },
    { name: 'phone_no', label: 'Phone', type: 'text' },
    { name: 'category', label: 'Category', type: 'text' },
    { name: 'aadhaar_path', label: 'Aadhaar', type: 'file' },
    { name: 'disability_cert_path', label: 'Certificate', type: 'file' },
    { name: 'photo_path', label: 'Photo', type: 'file' }
  ],
  'cricket-umpire': [
    { name: 'full_name', label: 'Umpire Name', type: 'text' },
    { name: 'father_name', label: 'Father Name', type: 'text' },
    { name: 'phone_no', label: 'Phone', type: 'text' },
    { name: 'email_id', label: 'Email', type: 'email' },
    { name: 'matches_count', label: 'Matches', type: 'number' },
    { name: 'experience_years', label: 'Experience (Yrs)', type: 'text' },
    { name: 'aadhaar_path', label: 'Aadhaar', type: 'file' },
    { name: 'photo_path', label: 'Photo', type: 'file' }
  ],

  // --- 3. EDUCATION CLUB ---
  'education-member': [
    { name: 'full_name', label: 'Full Name', type: 'text' },
    { name: 'father_name', label: 'Father Name', type: 'text' },
    { name: 'address', label: 'Full Address', type: 'textarea' },
    { name: 'phone_no', label: 'Phone Number', type: 'tel' },
    { name: 'email_id', label: 'Email ID', type: 'email' },
    { name: 'aadhaar_no', label: 'Aadhaar No', type: 'text' },
    { name: 'disability_cert_no', label: 'Disability Certificate', type: 'text' },
    { name: 'category', label: 'Club Preference', type: 'text' },
    { name: 'aadhaar_path', label: 'Aadhaar Card', type: 'file' },
    { name: 'photo_path', label: 'Photo', type: 'file' },
    { name: 'status', label: 'Status', type: 'text' }
  ],

  'education-student': [
    { name: 'full_name', label: 'Student Name', type: 'text' },       // Matches DB 'full_name'
    { name: 'father_name', label: 'Father Name', type: 'text' },
    { name: 'phone_no', label: 'Mobile Number', type: 'tel' },
    { name: 'school_college_name', label: 'College Name', type: 'text' },
    { name: 'current_class_year', label: 'Course/Year', type: 'text' },
    { name: 'aadhaar_no', label: 'Aadhaar No', type: 'text' },        // New Field
    { name: 'place_of_exam', label: 'Exam Center', type: 'text' },    // New Field
    { name: 'disability_certificate_path', label: 'Certificate', type: 'file' },
    { name: 'status', label: 'Status', type: 'text' }
  ],

  'education-scriber': [
    { name: 'full_name', label: 'Scribe Name', type: 'text' },
    { name: 'father_name', label: 'Father Name', type: 'text' },
    { name: 'phone_no', label: 'Mobile No', type: 'tel' },
    { name: 'qualification', label: 'Qualification', type: 'text' },
    { name: 'occupation', label: 'Occupation', type: 'text' },
    { name: 'subjects_of_interest', label: 'Subjects', type: 'text' },
    { name: 'present_location', label: 'Location', type: 'text' },
    { name: 'status', label: 'Status', type: 'text' }
  ],

  'education-volunteer': [
    { name: 'full_name', label: 'Name', type: 'text' },
    { name: 'phone_no', label: 'Phone', type: 'text' },
    { name: 'area_of_interest', label: 'Interest', type: 'text' },
    { name: 'availability', label: 'Availability', type: 'text' },
    { name: 'status', label: 'Status', type: 'text' }
  ],
  'education-donor': [
    { name: 'donor_name', label: 'Donor', type: 'text' },
    { name: 'amount', label: 'Amount', type: 'text' },
    { name: 'payment_id', label: 'Txn ID', type: 'text' },
    { name: 'email_id', label: 'Email', type: 'text' },
    { name: 'phone_no', label: 'Phone', type: 'text' },
    { name: 'pan_card_no', label: 'PAN', type: 'text' },
    { name: 'status', label: 'Status', type: 'text' }
  ],
  'cricket-donor': [
    { name: 'donor_name', label: 'Donor', type: 'text' },
    { name: 'amount', label: 'Amount', type: 'text' },
    { name: 'payment_id', label: 'Txn ID', type: 'text' },
    { name: 'email_id', label: 'Email', type: 'text' },
    { name: 'phone_no', label: 'Phone', type: 'text' },
    { name: 'pan_card_no', label: 'PAN', type: 'text' },
    { name: 'status', label: 'Status', type: 'text' }
  ],
  'music-donor': [
    { name: 'donor_name', label: 'Donor', type: 'text' },
    { name: 'amount', label: 'Amount', type: 'text' },
    { name: 'payment_id', label: 'Txn ID', type: 'text' },
    { name: 'email_id', label: 'Email', type: 'text' },
    { name: 'phone_no', label: 'Phone', type: 'text' },
    { name: 'pan_card_no', label: 'PAN', type: 'text' },
    { name: 'status', label: 'Status', type: 'text' }
  ],
  'business-donor': [
    { name: 'donor_name', label: 'Donor', type: 'text' },
    { name: 'amount', label: 'Amount', type: 'text' },
    { name: 'payment_id', label: 'Txn ID', type: 'text' },
    { name: 'email_id', label: 'Email', type: 'text' },
    { name: 'phone_no', label: 'Phone', type: 'text' },
    { name: 'pan_card_no', label: 'PAN', type: 'text' },
    { name: 'status', label: 'Status', type: 'text' }
  ],

  // --- 4. MUSIC CLUB ---
  'music-singer': [
    { name: 'full_name', label: 'Singer Name', type: 'text' },
    { name: 'father_name', label: 'Father Name', type: 'text' },
    { name: 'phone_no', label: 'Phone', type: 'text' },
    { name: 'email_id', label: 'Email', type: 'email' },
    { name: 'aadhaar_no', label: 'Aadhaar', type: 'text' },
    { name: 'disability_certificate_no', label: 'Disability ID', type: 'text' },
    { name: 'music_category', label: 'Category', type: 'text' },
    { name: 'aadhaar_path', label: 'Aadhaar', type: 'file' },
    { name: 'disability_certificate_path', label: 'Certificate', type: 'file' },
    { name: 'photo_path', label: 'Photo', type: 'file' }
  ],
  'music-judge': [
    { name: 'full_name', label: 'Judge Name', type: 'text' },
    { name: 'father_name', label: 'Father Name', type: 'text' },
    { name: 'phone_no', label: 'Phone', type: 'text' },
    { name: 'email_id', label: 'Email', type: 'email' },
    { name: 'aadhaar_no', label: 'Aadhaar', type: 'text' },
    { name: 'qualification', label: 'Qualification', type: 'text' },
    { name: 'occupation', label: 'Occupation', type: 'text' },
    { name: 'experience_years', label: 'Experience (Yrs)', type: 'text' },
    { name: 'aadhaar_path', label: 'Aadhaar', type: 'file' },
    { name: 'photo_path', label: 'Photo', type: 'file' }
  ],
  'music-member': [
    { name: 'full_name', label: 'Member Name', type: 'text' },
    { name: 'father_name', label: 'Father Name', type: 'text' },
    { name: 'phone_no', label: 'Phone', type: 'text' },
    { name: 'email_id', label: 'Email', type: 'email' },
    { name: 'aadhaar_no', label: 'Aadhaar', type: 'text' },
    { name: 'disability_certificate_no', label: 'Disability ID', type: 'text' },
    { name: 'music_category', label: 'Category', type: 'text' },
    { name: 'aadhaar_path', label: 'Aadhaar', type: 'file' },
    { name: 'disability_certificate_path', label: 'Certificate', type: 'file' },
    { name: 'photo_path', label: 'Photo', type: 'file' }
  ],

  // --- 5. BUSINESS CLUB ---
  'business-entrepreneur': [
    { name: 'full_name', label: 'Name', type: 'text' },
    { name: 'father_name', label: 'Father Name', type: 'text' },
    { name: 'phone_no', label: 'Phone', type: 'text' },
    { name: 'email_id', label: 'Email', type: 'text' },
    { name: 'aadhaar_no', label: 'Aadhaar', type: 'text' },
    { name: 'pan_no', label: 'PAN', type: 'text' },
    { name: 'company_name', label: 'Company', type: 'text' },
    { name: 'occupation', label: 'Role', type: 'text' },
    { name: 'experience_years', label: 'Exp (Yrs)', type: 'text' },
    { name: 'aadhaar_path', label: 'Aadhaar', type: 'file' },
    { name: 'photo_path', label: 'Photo', type: 'file' }
  ],
  'business-member': [
    { name: 'full_name', label: 'Member Name', type: 'text' },
    { name: 'father_name', label: 'Father Name', type: 'text' },
    { name: 'phone_no', label: 'Phone', type: 'text' },
    { name: 'email_id', label: 'Email', type: 'text' },
    { name: 'aadhaar_no', label: 'Aadhaar', type: 'text' },
    { name: 'pan_no', label: 'PAN', type: 'text' },
    { name: 'company_name', label: 'Company', type: 'text' },
    { name: 'occupation', label: 'Role', type: 'text' },
    { name: 'experience_years', label: 'Exp (Yrs)', type: 'text' },
    { name: 'aadhaar_path', label: 'Aadhaar', type: 'file' },
    { name: 'photo_path', label: 'Photo', type: 'file' }
  ],

  // --- 6. AWARDS ---
  'awards-application': [
    { name: 'full_name', label: 'Name', type: 'text' },
    { name: 'father_name', label: 'Father Name', type: 'text' },
    { name: 'phone_no', label: 'Phone', type: 'text' },
    { name: 'email_id', label: 'Email', type: 'text' },
    { name: 'aadhaar_no', label: 'Aadhaar', type: 'text' },
    { name: 'disability_category', label: 'Disability', type: 'text' },
    { name: 'occupation', label: 'Occupation', type: 'text' },
    { name: 'achievement', label: 'Achv', type: 'text' },
    { name: 'aadhaar_path', label: 'Aadhaar', type: 'file' },
    { name: 'disability_certificate_path', label: 'Certificate', type: 'file' },
    { name: 'photo_path', label: 'Photo', type: 'file' },
    { name: 'biodata_path', label: 'Bio', type: 'file' }
  ],
  'awards-sponsor': [
    { name: 'sponsorName', label: 'Sponsor/Company Name', type: 'text', required: true },
    { name: 'phone', label: 'Contact Number', type: 'tel', required: true },
    { name: 'amount', label: 'Pledge Amount (Optional)', type: 'number' },
    { name: 'message', label: 'Message', type: 'textarea' }
  ]
};